export function makePayloadInserirServicoAdicionais(inscricao, idsServicos){
    return {
        inscricao,
        idsServicos
    };
}

export function makePayloadDeletarServicoAdicionais(inscricao, idsServicos){
    return {
        inscricao,
        idsServicos
    };
}